export enum FolderManagerViewTypes {
  LIST = 'list',
  GRID = 'thumbnail',
  SLIDES = 'slides',
}

export enum FolderManagerItemTypes {
  FOLDER = 'folder',
  WORKSPACE = 'workspace',
  PRESENTATION = 'presentation',
  COLLECTION = 'collection',
  PERSON = 'person',
  HERO_IMAGE = 'hero_image',
  RESOURCE = 'resource',
  ASSET = 'asset,',
}

export enum FolderManagerActionTypes {
  NEW_PRESENTATION = 'new-presentation',
  NEW_PROJECT = 'new-project',
  NEW_COLLECTION = 'new-collection',
  NEW_ASSET = 'new-asset',
  NEW_FOLDER = 'new-folder',
  SLIDE_UPLOAD = 'slide-upload',
  SELECT = 'select',

  UPLOAD = 'upload',
  EXPORT = 'export',

  MANAGE_VERSIONS = 'manage-versions',
  MANAGE_THEME = 'manage-theme',
  ROW_CLICK = 'row-click',
  EDIT = 'edit',
  DELETE = 'delete',
  DOWNLOAD = 'download',
  DOWNLOAD_DECK = 'download-deck',
  COPY = 'copy',
  CLONE = 'clone',
  SHORTCUT = 'shortcut',
  MOVE = 'move',
  SHARE = 'share',
  CANCEL = 'cancel',
  SUBMIT = 'submit',
  RENAME = 'rename',
  NAVIGATE = 'navigate',

  GET_SUB_FOLDERS = 'get-sub-folders',
  GET_WORKSPACE = 'get-workspace',
  GET_SUB_ENTITIES_TYPES = 'get-entities-types',
  GET_DELETED_HIERARCHY = 'get-deleted-hierarchy',
  RESTORE = 'restore',
}

export interface FolderManagerFilters {
  query: string;
}

export interface FolderManagerAction {
  actionType: FolderManagerActionTypes;
  payload?: any;
  isMultiSelect?: boolean;
  onClear?: () => void;
}

export enum FolderManagerStatusTypes {
  COMPLETED = 'completed',
  PENDING = 'pending',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum FolderManagerMimeTypes {
  FOLDER = 'folder',
  WORKSPACE = 'workspace',
  PRESENTATION = 'presentation',
  SLIDE = 'slide',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  ZIP = 'application/zip',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PDF = 'application/pdf',
}
export interface FolderManagerDragEndPayload {
  id: string;
  type: string;
}

export interface FolderManagerDragStartPayload {
  id: string;
}

export interface FolderManagerFormErrors {
  [key: string]: { message: string };
}

export interface FolderManagerDialogStateEditedItem {
  id: string | number | null;
  name: string;
}

export interface FolderManagerBreadcrumb {
  id: string | number;
  name: string;
}

export interface FolderManagerBreadcrumbsProps {
  data: FolderManagerBreadcrumb[];
  fontSize?: string;
  onClick?: (data: any) => void;
}
